// Passive (proc) skills: Blast, Flare, Veil, Redoubled Offensive. Keep in sync
// with passiveSkillIds in cmd/dilmeterapi/passiveDamage.go.
export const PASSIVE_SKILL_IDS = new Set([58100, 58101, 58104, 58009]);
